export default __webpack_public_path__ + "static/media/Slider-1.82e07283.jpg";